import type { QuerySnapshot, DocumentData } from 'firebase/firestore';

/**
 * Maps a Firestore QuerySnapshot to an array of typed objects,
 * spreading doc data and injecting the document ID.
 *
 * By default the ID field is `id`. Pass `idField` to override
 * (e.g. `'uid'` for the users collection).
 */
export function mapDocs<T>(
    snapshot: QuerySnapshot<DocumentData>,
    idField: string = 'id',
): T[] {
    return snapshot.docs.map(doc => ({
        [idField]: doc.id,
        ...doc.data(),
    } as T));
}
